import React from "react";

import { useAlert } from "../../context/AlertContext";

import Icon from "../icon/Icon";

const Alert = () => {
  const { alert, setAlert } = useAlert();

  if (!alert?.message) {
    return null;
  }

  return (
    <div className={`a-alert -${alert?.type} space-between`}>
      <div className="a-alert__left">
        <Icon name={`alert_${alert?.type}`} />
        <div className="-text">
          <span className="-type">{alert?.type}</span>
          <span className="-message">{alert?.message}</span>
        </div>
      </div>
      <span className="removeItemIcon" onClick={() => setAlert(null)} />
    </div>
  );
};

export default Alert;
